import { createSlice } from '@reduxjs/toolkit'

const initialState = {
	parallaxProps: {},
	pages: [],
	originFromAllAuctionScreen: false,
	allAuctionScreenEmbedPath: '',

	/* TODO: This state piece needs a huge refactor | Hard to maintain */
	isBackAllItems: { isBack: false, itemsName: '', backPath: '' },

	/* TODO: This state piece needs a huge refactor | Don't understand fully how it's managed & cleanup */
	anonymousBidAttempt: { isBidAttempt: false, backAuctionBidPath: '', bidAttemptAmount: 0 },
}

const navigationSlice = createSlice({
	name: 'navigation',
	initialState,
	reducers: {
		setIsBackButton(state, { payload }) {
			return { ...state, isBackAllItems: { ...state.isBackAllItems, ...payload } }
		},
		setParallaxProps(state, { payload }) {
			return { ...state, parallaxProps: { ...payload } }
		},
		setAnonymousBidAttempt(state, { payload }) {
			return { ...state, anonymousBidAttempt: { ...payload } }
		},
		setPaginationPages(state, { payload }) {
			return { ...state, pages: [...payload] }
		},
		updateGlobalNavMixData(state, { payload }) {
			return { ...state, ...payload }
		},
	},
})

export const {
	setIsBackButton,
	setParallaxProps,
	setAnonymousBidAttempt,
	setPaginationPages,
	updateGlobalNavMixData,
} = navigationSlice.actions

export default navigationSlice.reducer
